__turbopack_context__.v({
  "assurances": "WdDm2q_assurances",
  "body": "WdDm2q_body",
  "changeButton": "WdDm2q_changeButton",
  "consultation": "WdDm2q_consultation",
  "consultationBody": "WdDm2q_consultationBody",
  "customQuestion": "WdDm2q_customQuestion",
  "eyebrow": "WdDm2q_eyebrow",
  "header": "WdDm2q_header",
  "hero": "WdDm2q_hero",
  "methodProof": "WdDm2q_methodProof",
  "selectedConcern": "WdDm2q_selectedConcern",
  "signalMark": "WdDm2q_signalMark",
  "signals": "WdDm2q_signals",
  "skipButton": "WdDm2q_skipButton",
  "title": "WdDm2q_title",
  "topicButton": "WdDm2q_topicButton",
  "topicGrid": "WdDm2q_topicGrid",
  "topicHelper": "WdDm2q_topicHelper",
  "topicLegend": "WdDm2q_topicLegend",
  "topicLens": "WdDm2q_topicLens",
  "topicMeta": "WdDm2q_topicMeta",
  "topicTitle": "WdDm2q_topicTitle",
  "visual": "WdDm2q_visual",
  "visualEyebrow": "WdDm2q_visualEyebrow",
});
